interface LayoutDownloadProps {
  children: React.ReactNode;
  className?: string;
}

export default function LayoutDownload({ children, className }: LayoutDownloadProps) {
  return (
    <div className='flex flex-1 flex-col w-full'>
      <main className={`flex-1 ${className}`}>{children}</main>
    </div>
  );
}
